/* 
This is a hardcoded copy of the eventTypes returned from https://api.justgiving.com/{appId}/v1/event/types (29/07/19)
To reduce the length we have also removed the types prefixed 'personal'
*/

export default [
  { label: 'Running Marathons', value: 'Running_Marathons', isSelected: false },
  { label: 'Treks', value: 'Treks', isSelected: false },
  { label: 'Walks', value: 'Walks', isSelected: false },
  { label: 'Cycling', value: 'Cycling', isSelected: false },
  { label: 'Swimming', value: 'Swimming', isSelected: false },
  { label: 'Birthday', value: 'Birthday', isSelected: false },
  { label: 'Wedding', value: 'Wedding', isSelected: false },
  { label: 'Other Celebration', value: 'OtherCelebration', isSelected: false },
  { label: 'Christening', value: 'Christening', isSelected: false },
  { label: 'InMemory', value: 'InMemory', isSelected: false },
  { label: 'Anniversaries', value: 'Anniversaries', isSelected: false },
  { label: 'Triathlons', value: 'Triathlons', isSelected: false },
  {
    label: 'Parachuting Skydives',
    value: 'Parachuting_Skydives',
    isSelected: false,
  },
  {
    label: 'OtherSporting Events',
    value: 'OtherSportingEvents',
    isSelected: false,
  },
  {
    label: 'New Years Resolutions',
    value: 'NewYearsResolutions',
    isSelected: false,
  },
  { label: 'Christmas', value: 'Christmas', isSelected: false },
  {
    label: 'Other Personal Challenge',
    value: 'OtherPersonalChallenge',
    isSelected: false,
  },
  { label: 'Charity Appeal', value: 'CharityAppeal', isSelected: false },
  { label: 'Individual Appeal', value: 'IndividualAppeal', isSelected: false },
  { label: 'Company Appeal', value: 'CompanyAppeal', isSelected: false },
  { label: 'Streaming Gaming', value: 'Streaming_Gaming', isSelected: false },
];
